/* istanbul ignore file */
import React from 'react';
import { Dropdown, TimeUnitsDropdown, DefaultInputPropTypes } from 'framework/form';
import { Box } from '@mui/material';
import { MultiInputWrapperLayout } from 'framework/ui/layout';

const AssetBillingCycleInput = ({ source, label, ...props }: DefaultInputPropTypes<any>) => {
  return (
    <MultiInputWrapperLayout
      label={label as any}
      inputSources={[`${source}.amount`, `${source}.timeUnit`]}
      gridTemplateColumns="37px minmax(110px, 1fr) 130px"
      isRequired
    >
      <Box sx={{ paddingTop: '9px' }}>Every</Box>
      <Dropdown
        {...props}
        source={`${source}.amount`}
        options={Array(40)
          .fill(0)
          .map((_, index) => {
            const value = (index + 1).toString();

            return { value, label: value };
          })}
        placeholder=""
      />
      <TimeUnitsDropdown source={`${source}.timeUnit`} />
    </MultiInputWrapperLayout>
  );
};

export default AssetBillingCycleInput;
